import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "/leave";

export type listType = {
  leave_status?: string;
  leave_period?: number;
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
};

export class settingLeavePeriodApi extends BaseAPI {
  static getAllLeavePeriod(query: listType): Promise<any> {
    return this.api.get(`${path}/period?status=active`, {
      params: { ...query },
    });
  }
  static getLeavePeriodById(id: number): Promise<any> {
    return this.api.get(`${path}/period/${id}`);
  }

  static createLeavePeriod(body: any): Promise<any> {
    return this.api.post(`${path}/period/create`, body);
  }

  static updateLeavePeriod(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/period/${id}/update`, body);
  }

  static deleteLeavePeriod(id: number): Promise<any> {
    return this.api.delete(`${path}/period/${id}/delete`);
  }

  static getLeaveEmployeeList(id: number, query: listType): Promise<any> {
    return this.api.get(`${path}/employee/${id}/list`, {
      params: { ...query },
    });
  }

  static getLeaveEmployeeDetail(id: number, employee_id: number): Promise<any> {
    return this.api.get(`${path}/employee/${employee_id}/${id}/detail`);
  }

  static updateEmployeeHoliday(body: any, id: number): Promise<any> {
    return this.api.post(`${path}/employee/${id}/detail`, body);
  }
  static dropdownYear(): Promise<AxiosResponse> {
    return this.api.get(`${path}/dropdown-year`)
  }
}
